import { ToastProvider } from 'react-toast-notifications';
import React, { Fragment, useEffect, useRef } from 'react';
import language from '../../config/es';

import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';
import {
  findByType,
  createMessage,
  deleteMessage,
  updateMessage,
} from '../../redux/message.duck';
import { findByConcept } from '../../redux/type.duck';
import app from '../../config/application';

import { es_vacio } from '../../config/validate';
//Session user
import SessionConfig from '../../config/session_config';
//Crud compartido
import {
  useCrudState,
  useCrudLifecycle,
} from '../../components/Crud/crudHooks';
import {
  buildEditColumn,
  createFormState,
  addFieldError,
  renderDeleteAction,
  requireValues,
  toIdList,
} from '../../components/Crud/crudHelpers';
import {
  RequiredFieldsAlert,
  SelectField,
  TextField,
} from '../../components/Crud/CrudFields';
import {
  CrudButtons,
  CrudDataTable,
  CrudPage,
} from '../../components/Crud/CrudLayout';

const Message = () => {
  const ref = useRef();
  const dispatch = useAppDispatch();
  const {
    data,
    refreshState,
    updateState,
    viewNotification,
    handleSelectRow,
    initStateDelete,
  } = useCrudState({
    ...createFormState({ editTransaction: true }),
    id: null,
    collectionEntity: { value: 0, label: '', error: '', auth: '' },
    message: { value: 0, label: '', error: '', action: '' },
    listMessages: [],
    responseCreate: [],
    responseEdit: [],
    dataRows: [],
    showloadingSociety: false,
    showloadingEntity: true,
    showloadingMoney: true,
    table: true,
    listMoney: [],
    money: { value: 0, label: '', error: '' },
    typesMessage: [],
    messageMoney: '',
    currency: { value: '', error: '' },
    collectingEntity: { value: '', error: '' },
    nameMessage: { value: '', error: '' },
    descriptionMessage: { value: '', error: '' },
    codeMessage: { value: '', error: '' },
    entities: [],
    username: 'admin',
    auth: JSON.parse(sessionStorage.getItem('user')),
  });
  data.listMessages = useSelector((store) => store.MessageReducer.messages);
  data.typesMessage = useSelector((store) => store.typeReducer.types);

  useEffect(() => {
    console.log(data.message.value);
    if (
      data.message.value > 0 &&
      !es_vacio(data.message.value) &&
      data.message.action !== '1'
    ) {
      void loadMesages();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.message]);
  useCrudLifecycle(ref, data, () => {
    void loadData();
  });

  const loadMesages = async () => {
    data.pendingData = true;
    data.enable = false;
    refreshState();
    await dispatch(findByType(data.message.value, data.auth.id.user.username));
    data.pendingData = false;
    data.enable = true;
    refreshState();
  };
  const loadData = async () => {
    initTable();
    await loadTypes();
  };
  const loadTypes = async () => {
    await dispatch(findByConcept(app.data.types.typeMessage));
    data.showloadingSociety = true;
    refreshState();
  };
  const initTable = () => {
    data.columns = [
      buildEditColumn(handleButtonEdit, { width: '40px', idKey: 'Id' }),
      {
        name: language.messages.message.codeMessage,
        sortable: false,
        wrap: true,
        width: '70px',
        cell: (row) => (
          <div className="small text-primary text-uppercase">{row.code}</div>
        ),
      },
      {
        name: language.messages.message.nameMessage,
        sortable: false,
        width: '400px',
        cell: (row) => (
          <span>
            <div className="small text-uppercase">{row.name}</div>
            <div className="text-muted small text-nowrap">
              {row.description}
            </div>
          </span>
        ),
      },
    ];

    updateState(data.columns, 'columns');
  };
  const handleButtonEdit = (row) => {
    data.pendingData = false;
    data.id = row.id;
    data.message.value = row.messageType.id;
    data.message.label = row.messageType.name;
    data.message.action = '1';
    data.nameMessage.value = row.name;
    data.descriptionMessage.value = row.description;
    data.codeMessage.value = row.code;
    refreshState();
  };

  const updateSelect = async (value) => {
    data.message = value;
    refreshState();
  };
  const onChange = (event) => {
    switch (event.target.name) {
      case 'nameMessage':
        data.nameMessage.value = event.target.value;
        data.nameMessage.error = '';
        break;
      case 'descriptionMessage':
        data.descriptionMessage.value = event.target.value;
        data.descriptionMessage.error = '';
        break;
      case 'codeMessage':
        data.codeMessage.value = event.target.value;
        data.codeMessage.error = '';
        break;
      default:
        break;
    }
    refreshState();
  };

  const handleDelete = () => {
    void disableData();
  };
  const init = () => {
    clearForm();
    void loadMesages();
    initTable();
  };
  const clearForm = () => {
    data.editType = true;
    data.id = null;
    data.nameMessage = { value: '', label: '' };
    data.descriptionMessage = { value: '', label: '' };
    data.codeMessage = { value: '', label: '' };
  };
  const disableData = async () => {
    if (data.selectedRows.length > 0) {
      let lsDelete = toIdList(data.selectedRows, {
        authUser: data.auth.id.user.userId,
      });
      initStateDelete(false);

      let response = await dispatch(
        deleteMessage(lsDelete, data.auth.id.user.username)
      );
      if (response.code !== undefined) {
        viewNotification(response.message, 'error');
        initStateDelete(true);
      } else {
        if (response.data.code === '403') {
          viewNotification(language.messages.messageNoAccessRemove, 'error');
        } else {
          viewNotification(language.messages.msmDisableAll, 'success');
        }
        await loadMesages();
        initStateDelete(true);
      }
    }
  };

  const contextActions = renderDeleteAction(
    handleDelete,
    data.enable,
    'Dar de Baja'
  );
  const handleSaveResponse = (response, noAccessMessage) => {
    if (response.data === noAccessMessage) {
      viewNotification(noAccessMessage, 'error');
      data.pendingData = false;
    } else if (response.status === 200) {
      if (response.data === 0) {
        viewNotification(language.messages.codeDuplicated, 'error');
        data.pendingData = false;
      } else {
        viewNotification(
          language.messages.msmRegister.replace(
            '{0}',
            data.collectingEntity.value
          ),
          'success'
        );
      }
    } else {
      viewNotification(language.messages.msmErrorExist, 'error');
      data.pendingData = false;
    }
  };
  const saveData = async () => {
    validate();
    if (data.errors.length === 0) {
      data.enable = false;
      data.pendingData = true;
      refreshState();
      if (data.id === null) {
        let json = {
          idType: data.message.value,
          name: data.nameMessage.value,
          description: data.descriptionMessage.value,
          code: data.codeMessage.value,
          status: 1,
          userAdmin: data.username,
        };
        let response = await dispatch(
          createMessage(json, data.auth.id.user.username)
        );
        handleSaveResponse(
          response,
          language.messages.messageNoAccessRegister
        );
      } else {
        let json = {
          id: data.id,
          type: data.message.value,
          name: data.nameMessage.value,
          description: data.descriptionMessage.value,
          code: data.codeMessage.value,
          status: 1,
          userAdmin: data.username,
        };
        let response = await dispatch(
          updateMessage(json, data.auth.id.user.username)
        );
        handleSaveResponse(response, language.messages.messageNoAccessEdit);
      }
      data.pendingData = false;
      data.enable = true;
      init();
    } else {
      viewNotification(language.messages.msmErrorForm, 'error');
    }
    refreshState();
  };
  const validate = () => {
    clearError();
    requireValues(data, ['message', 'nameMessage', 'descriptionMessage']);
    if (es_vacio(data.codeMessage.value)) {
      addFieldError(
        data,
        'codeMessage',
        language.messages.warning_required_field,
        'descriptionMessage'
      );
    }
  };
  const clearError = () => {
    data.errors = [];
    data.message.error = '';
    data.nameMessage.error = '';
    data.descriptionMessage.error = '';
    data.codeMessage.error = '';
  };
  const cleaningForm = () => {
    clearForm();
    refreshState();
  };

  return (
    <Fragment>
      <SessionConfig ref={ref} />
      <br />
      <CrudPage
        formCol={{ md: 5, xl: 4 }}
        formTitle={language.messages.titleMessages}
        form={
          <form autoComplete="off">
            <RequiredFieldsAlert />
            <SelectField
              label={language.messages.message.typeMessage}
              loading={data.showloadingSociety}
              isDisabled={data.id !== null}
              name="message"
              options={data.typesMessage}
              field={data.message}
              showAuth
              onChange={updateSelect}
            />
            <TextField
              label={language.messages.message.nameMessage}
              autoComplete="nameMessage"
              name="nameMessage"
              field={data.nameMessage}
              onChange={onChange}
            />
            <TextField
              label={language.messages.message.descriptionMessage}
              as="textarea"
              name="descriptionMessage"
              field={data.descriptionMessage}
              onChange={onChange}
            />
            <TextField
              label={language.messages.message.codeMessage}
              disabled={data.id !== null}
              name="codeMessage"
              field={data.codeMessage}
              onChange={onChange}
            />
            <CrudButtons
              wrapped
              enable={data.enable}
              isNew={data.id === null}
              onSave={saveData}
              onClear={cleaningForm}
              onReload={loadMesages}
            />
          </form>
        }
        tableCol={{ md: 7, xl: 8 }}
        tableClassTitle=" text-uppercase text-capitalize"
        tableIcon="fa fa-list"
        tableTitle={language.messages.gridMessagesTitle}
        table={
          <CrudDataTable
            data={data}
            show={data.table}
            noHeader={es_vacio(data.message.label)}
            title={data.message.label}
            rows={data.listMessages}
            onSelect={handleSelectRow}
            pointerOnHover={true}
            actions={contextActions}
          />
        }
      />
    </Fragment>
  );
};
const App = () => (
  <ToastProvider>
    <Message />
  </ToastProvider>
);
export default App;
